if (typeof debounce === 'undefined') {
  var debounce = function(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}

/**
 * @class
 * @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      // Move the drawer outside the header stacking context.
      const wrapper = document.getElementById('wrapper');

      if (this.menu && wrapper) {
        document.querySelectorAll('.mobile-menu-drawer').forEach((el) => {
          if (el !== this.menu) el.remove();
        });

        wrapper.appendChild(this.menu);
      }

      this._scrollTicking = false;
      this._stickyOffset = 0;

      // Open and close through OverlayManager.
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        e.preventDefault();

        if (OverlayManager.isOpen(this.menu)) {
          OverlayManager.close(this.menu);
        } else {
          OverlayManager.open(this.menu);
        }

        window.dispatchEvent(new Event('resize.resize-select'));
      });

      document.addEventListener('panel:open', (e) => {
        if (e.detail.panel === this.menu) {
          this.toggle.classList.add('active');
          this.setHeaderBottom();
        }
      });

      document.addEventListener('panel:closed', (e) => {
        if (e.detail.panel === this.menu) {
          this.toggle.classList.remove('active');
          this.toggle.removeAttribute('open');
        }
      });

      this._cacheStickyOffset();

      window.addEventListener('resize', debounce(() => {
        this._cacheStickyOffset();
        this.setHeaderBottom();
      }, 100));

      window.addEventListener('scroll', () => {
        if (!this._scrollTicking) {
          this._scrollTicking = true;

          requestAnimationFrame(() => {
            this.setStickyClass();
            this.setHeaderOffset();
            this.setHeaderHeight();
            this.setHeaderBottom();
            this._scrollTicking = false;
          });
        }
      }, { passive: true });

      window.dispatchEvent(new Event('scroll'));

      // Keep menu positioning in sync with header geometry.
      if ('ResizeObserver' in window) {
        this._headerResizeObserver = new ResizeObserver(() => {
          this.setHeaderOffset();
          this.setHeaderHeight();
          this.setHeaderBottom();
        });

        this._headerResizeObserver.observe(this);

        const a_bar_section = document.querySelector('.announcement-bar-section');

        if (a_bar_section) {
          this._headerResizeObserver.observe(a_bar_section);
        }
      }

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', () => this.setAnnouncementHeight(), {
          passive: true
        });

        window.dispatchEvent(new Event('resize'));
      }

      // Existing menu controls.
      this.menu.querySelectorAll('summary').forEach(summary => {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      });

      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
    }

    _cacheStickyOffset() {
      if (this.classList.contains('header-sticky--active')) {
        if (this.classList.contains('is-sticky')) {
          return;
        }

        this._stickyOffset =
          parseInt(this.header_section.getBoundingClientRect().top, 10) +
          document.documentElement.scrollTop;
      }
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle(
          'is-sticky',
          window.scrollY >= this._stickyOffset && window.scrollY > 0
        );
      }
    }

    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');

      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }

    disconnectedCallback() {
      if (this._headerResizeObserver) {
        this._headerResizeObserver.disconnect();
        this._headerResizeObserver = null;
      }
    }

    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }

    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    setHeaderBottom() {
      let b = this.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty(
        '--header-bottom',
        Math.max(0, b) + 'px'
      );
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;

      // Collection accordions expand inline using native details behavior.
      // Do not apply the sliding-panel behavior to them.
      if (detailsElement.classList.contains('inaury-mobile-accordion')) {
        return;
      }

      const parentLinksEnabled = this.menu.dataset.parentLinks === 'true';

      // When parent links are enabled, only the arrow opens the submenu.
      if (parentLinksEnabled) {
        event.preventDefault();

        const isArrowClick = event.target.closest('.link-forward');

        if (!isArrowClick) {
          const anchor = summaryElement.querySelector('a');

          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }

          return;
        }

        detailsElement.setAttribute('open', '');
      }

      const parentMenuElement = detailsElement.closest('.link-container');

      // Load deferred submenu content on first open.
      const tpl = detailsElement.querySelector(
        ':scope > template.mobile-menu-deferred'
      );

      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));

        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button => {
          button.addEventListener('click', this.onCloseButtonClick.bind(this));
        });

        detailsElement.querySelectorAll('details.link-container summary').forEach(summary => {
          summary.addEventListener('click', this.onSummaryClick.bind(this));
        });
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');

        if (parentMenuElement) {
          parentMenuElement.classList.add('submenu-open');
        }
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();

      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('theme-header', ThemeHeader);
}

/**
 * @class
 * @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        '.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu'
      );

      if (!this.submenus.length) {
        return;
      }

      window.addEventListener('resize', debounce(() => {
        this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(() => {
        this.resizeSubMenus();
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ':scope >.menu-item-has-children>.sub-menu'
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth;
          let l =
            sub_submenu.parentElement.parentElement.getBoundingClientRect().left +
            sub_submenu.parentElement.parentElement.clientWidth +
            10;

          let total = w + l;

          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }

  customElements.define('full-menu', FullMenu);
}